/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLabelFill: {
  name: 'label-fill';
  data: string;
} = {
  name: 'label-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.062.504a.5.5 0 0 0-.558.558l1 8a.5.5 0 0 0 .142.292l6 6a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.706l-6-6.002a.5.5 0 0 0-.292-.142l-8-1ZM6 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
